var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h3',{staticClass:"mb-3"},[(_vm.hasIcon)?_c('i',{staticClass:"text-dark",class:_vm.icon,style:('font-size:' + _vm.iconSize + 'px;margin-right:10px;cursor:pointer'),on:{"click":function($event){return _vm.goBack()}}}):_vm._e(),_vm._v(_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }